var _style, _rect, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluorescentOutput({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "16.3px",
    height: "16.1px",
    viewBox: "0 0 16.3 16.1",
    style: {
      enableBackground: "new 0 0 16.3 16.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fluorescent Output") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 4.4,
    className: "st0",
    width: 15.4,
    height: 7.3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 7.8,
    cy: 8.1,
    rx: 2.2,
    ry: 2.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluorescentOutput);
export default __webpack_public_path__ + "static/media/FluorescentOutput.9b30f4083377f78e0d684c0e839283d3.svg";
export { ForwardRef as ReactComponent };